import { render, staticRenderFns } from "./MyCollectionIcon.vue?vue&type=template&id=69fa287e"
import script from "./MyCollectionIcon.vue?vue&type=script&lang=js"
export * from "./MyCollectionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports